export default {"src":"/_next/static/media/icone-aura.4c12446b.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};